import { render, staticRenderFns } from "./ArticleAuthorsDetail.vue?vue&type=template&id=367151e4&lang=html&"
import script from "./ArticleAuthorsDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleAuthorsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports